import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ToolTemplateBuilder } from '../../models/builders/tool-template.builder';
import { ToolTemplate } from '../../models/tool-template';
import { getErrorHandlingOptions } from '../base/headers';

const toolTemplateBody = (toolTemplate: ToolTemplate) => ({
  name: toolTemplate.name,
  description: toolTemplate.description,
  tools: toolTemplate.tools
});

@Injectable()
export class ToolTemplateApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }tool-templates`;
  }

  getToolTemplates() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(ToolTemplateBuilder.fromList)
      );
  }

  getToolTemplate(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(ToolTemplateBuilder.fromJson)
      );
  }

  createToolTemplate(toolTemplate) {
    return this.httpClient.post(this.apiUrl, toolTemplateBody(toolTemplate)).pipe(map(ToolTemplateBuilder.fromJson));
  }

  updateToolTemplate(toolTemplate: ToolTemplate) {
    return this.httpClient.put(`${ this.apiUrl }/${ toolTemplate.hash }`, toolTemplateBody(toolTemplate));
  }

  deleteToolTemplate(toolTemplate: ToolTemplate) {
    return this.httpClient.delete(`${ this.apiUrl }/${ toolTemplate.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/tool-template-api.service.ts